import * as React from 'react';
import { Status } from './types';
import { useSession } from './useSession';
var useEffect = React.useEffect, useRef = React.useRef;
var ONE_MINUTE = 1 * 60 * 1000;
function shouldRefresh(status) {
    return status === Status.Authenticated;
}
export var SessionRefresh = function (_a) {
    var children = _a.children;
    var session = useSession();
    var status = session.status, refresh = session.refresh, expiry = session.expiry;
    var refreshInterval = useRef(undefined);
    useEffect(function () {
        var wasUserActivityInInterval = false;
        /**
         * Record that there was user activity since the last refresh
         */
        var handleUserActivity = function () {
            wasUserActivityInInterval = true;
        };
        /**
         * Refresh if there has been user activity since the last refresh
         */
        var handleInterval = function () {
            if (!wasUserActivityInInterval) {
                return;
            }
            refresh();
        };
        var start = function () {
            // start refreshing when the session status has changed to authenticated
            //  or the sessiwon is authenticated and the expiry has changed
            if (status !== Status.Authenticated || !expiry) {
                return;
            }
            window.addEventListener('click', handleUserActivity);
            window.addEventListener('keydown', handleUserActivity);
            window.addEventListener('mousemove', handleUserActivity);
            refreshInterval.current = window.setTimeout(handleInterval, expiry - Date.now() - ONE_MINUTE);
        };
        var stop = function () {
            // stop refreshing  when the session switches from authenticated to unauthenticated
            window.removeEventListener('click', handleUserActivity);
            window.removeEventListener('keydown', handleUserActivity);
            window.removeEventListener('mousemove', handleUserActivity);
            window.clearTimeout(refreshInterval.current);
        };
        if (shouldRefresh(status)) {
            start();
        }
        else {
            stop();
        }
        return function () { return stop(); };
    }, [status, refresh, expiry]);
    if (children !== null) {
        return React.createElement(React.Fragment, null, children);
    }
    return null;
};
//# sourceMappingURL=SessionRefresh.js.map